export const ReportTypesConstants = {
  FULL: "FULL",
  LABELS: "LABELS",
  BOX_OFFICE: "BOX_OFFICE",
  USERS: "USERS",
  USER_SUMMARY: "USER_SUMMARY"
};
